//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'wash',
  components: {
  },
  data () {
    return {
      count:{
        'xidi':0,
        'time_out':0,
      },
      nav:[
        {
          title:'收衣码录单',
          path:'/bagCodeRecord/1',
          auth:'bagCodeRecord',
          img:this.$customerAsset('bagCodeRecordIcon', '/static/images/status1.png'),
        },
        {
          title:'会员录单',
          path:'/bagCodeRecord/2',
          auth:'phoneRecord',
          img:this.$customerAsset('memberRecordIcon', '/static/images/status5.png'),
        },
        {
          title:'非会员录单',
          path:'/bagCodeRecord/3',
          auth:'phoneRecord',
          img:this.$customerAsset('nonMemberRecordIcon', '/static/images/status5.png'),
        },
        {
          title:'衣物上挂',
          path:'/upClothe',
          auth:'upClothe',
          img:'/static/images/store-visit-lined.png',
        },
        {
          title:'自有衣物上挂',
          path:'/upCustomClothe',
          auth:'upCustomClothe',
          img:'/static/images/upCustomClothe.png',
        },
        {
          title:'顾客取衣',
          path:'/pickClothe',
          auth:'pickClothe',
          img:'/static/images/pickup.png',
        },
        {
          title:'附件补录',
          path:'/annex',
          auth:'annex',
          img:'/static/images/bar.png',
        },
        {
          title:'撤单',
          path:'/cancelRecord',
          auth:'cancelRecord',
          img:'/static/images/submit.png',
        },
        {
          title:'回店记录',
          path:'/backStore',
          auth:'backStore',
          img:'/static/images/store-visit-lined.png',
        },
      ],
      nav1:[
        {
          title:'今日送洗',
          path:'/todayRecordList',
          auth:'todayRecordList',
          img:'/static/images/drivered.png',
        },
        {
          title:'手机号查询',
          path:'/recordPhoneList',
          auth:'recordPhoneList',
          img:'/static/images/pickuped.png',
        },
        {
          title:'洗涤中',
          path:'/clotheWash',
          auth:'clotheWash',
          img:'/static/images/arrivaled.png',
          key:'xidi'
        },
        {
          title:'上挂列表',
          path:'/upList',
          auth:'upList',
          img:'/static/images/upList.png',
        },
        {
          title:'取衣记录',
          path:'/pickList',
          auth:'pickClothe',
          img:'/static/images/pickup.png',
        },
        {
          title:'超时衣物',
          path:'/timeOutClotheWash',
          auth:'timeOutClotheWash',
          img:'/static/images/timeout.png',
          key:'time_out'
        },
        {
          title:'衣物图片',
          path:'/clothePhoto',
          auth:'clothePhoto',
          img:'/static/images/photo.png',
        },
        {
          title:'条码查询',
          path:'/barOrder',
          auth:'barOrder',
          img:'/static/images/bar.png',
        },
        {
          title:'综合查询',
          path:'/recordList',
          auth:'recordList',
          img:'/static/images/status6.png',
        },
      ],
    }
  },
  created(){
    this.getClotheCount();
  
  },
  mounted(){

  },
  methods:{
    isNavVisible(item){
      if(!item.customers){
        return true;
      }
      return this.$customer && item.customers.indexOf(this.$customer.key) > -1;
    },
    hasAuth(list){
      return list.some((item)=>{
        return this.isNavVisible(item) && this.$func.checkAuth(item.auth);
      })
    },
    getClotheCount(){
      this.$api.getClotheCount({}).then((res)=>{
        this.count = res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/recordOrder.vue